<app-modal-refactor
  [size]="sizeModal || 'lg'"
  [showImage]="!!image"
  [image]="image"
  [isNoCkn]=true
  [imageClose]="'../../../assets/images/Close_modal.svg'"
  [showImageClose]=true
  >
  <div body class="containerError">
    <span class="tittleError gapline" [ngStyle]="{'font-weight': fontWeightTitleError}">{{ titleError | translate }}</span>
    <span class="fs-28px gapline text-white descError" style="margin-bottom: 0;" [innerText]="msgError | translate"></span>
    <span *ngIf="!isAllPass && showListPassengers" class="textpasseger gapline text-white" >{{ 'modalnockn.pssmst' | translate}}</span>
    <div *ngIf="!isAllPass && showListPassengers"><span *ngFor="let p of passengerSelected" class="textpss-labels">{{ p.displayName | titlecase }}<br></span></div>
    <div class="errorsBtnsPnr gapline">
      <button *ngIf="showButton" type="button" class="error-btn {{backGroundButton}} {{colorFontButton}}" (click)="actionBtn()">
        <div class="error-btn-container">
          <img *ngIf="showIconImage" class="error-btn-img"
            [src]="urlIconImage" alt="Reload">
          <span>{{ buttonCopy | translate }}</span>
        </div>
      </button>
      <button *ngIf="showCancelButton" type="button" class="error-btn {{backGroundButton}} {{colorFontButton}}" (click)="actionBtnCancel()">
        <div class="error-btn-container">
          <span>{{ cancelButtonText | translate }}</span>
        </div>
      </button>
    </div>
    <div>
   <span class="errorNumberDescrip">{{codeError}} </span>
  </div>
  </div>
</app-modal-refactor>
